import React, { useEffect, useState } from 'react';
import { LayoutDashboard, FileText, History, Euro, LogOut } from 'lucide-react';
import { motion } from 'framer-motion';
import { cn } from '../utils/cn.js';
import Assets from './Images.js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import APIENDPOINT from './config.js';
const ICON_MAP = {
    'Dashboard': LayoutDashboard,
    'Booking': FileText,
    'History': History,
    'Price': Euro
};

export const Navbar = ({ activeTab, setActiveTab }) => {
    const [tabs, setTabs] = useState([]);
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                const res = await axios.get(`${APIENDPOINT}get_menu.php?user_type=${user.user_type}`);

                const menuWithIcons = res.data.map(item => ({
                    id: item.path, 
                    label: item.menu,
                    icon: ICON_MAP[item.menu] || FileText 
                }));
                setTabs(menuWithIcons);
            } catch (err) {
                console.error("Failed to fetch menu", err);
            }
        };

        if (user) fetchMenu();
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/login');
    };

    return (
        <>
            {/* DESKTOP TOP NAVBAR */}
            <nav className="hidden md:block bg-black border-b border-gray-800 sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="h-16 flex items-center justify-between">
                        <div className="flex flex-shrink-0">
                            <img src={Assets.Logo} className="w-60" alt="Logo" />
                        </div>
                        <div className="flex items-center space-x-4">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={cn(
                                        "inline-flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors",
                                        activeTab === tab.id
                                            ? "bg-emerald-600 text-white"
                                            : "text-gray-300 hover:text-white hover:bg-gray-800"
                                    )}
                                >
                                    <tab.icon className="w-4 h-4 mr-2" />
                                    {tab.label}
                                </button>
                            ))}
                            <button
                                onClick={handleLogout}
                                className="text-gray-300 hover:text-red-400 ml-4 p-2"
                            >
                                <LogOut className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* MOBILE BOTTOM NAVBAR */}
            <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 pb-safe">
                <div className="flex justify-around items-center h-16">
                    {tabs.map((tab) => {
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className="flex flex-col items-center justify-center flex-1 transition-colors relative"
                            >
                                {isActive && (
                                    <motion.div
                                        layoutId="activeTab"
                                        className="absolute top-[40px] w-12 h-1 bg-emerald-500 rounded-b-md"
                                    />
                                )}
                                <tab.icon className={cn(
                                    "w-5 h-5 mb-1",
                                    isActive ? "text-emerald-600" : "text-gray-500"
                                )} />
                                <span className={cn(
                                    "text-[10px] font-medium uppercase tracking-wider",
                                    isActive ? "text-emerald-600" : "text-gray-500"
                                )}>
                                    {tab.label}
                                </span>

                            </button>
                        );
                    })}
                    <button
                        onClick={handleLogout}
                        className="text-red-400 p-2 mr-3"
                    >
                        <LogOut className="w-5 h-5" />
                    </button>
                </div>
            </nav>
        </>
    );
};